import React from 'react';
import {Link} from 'react-router-dom';
import {IconButton, Tooltip} from 'material-ui';
import EditIcon from 'material-ui-icons/Edit';

const pageTemplatesGridColumns = [{
    id: 'id',
    Header: 'Id',
    accessor: 'id',
    width: 50,
}, {
    Header: 'Template Name',
    accessor: 'template',
}, {
    Header: 'Actions',
    width: 100,
    sortable: false,
    Cell: (props) => <Link to={"/template/" + props.row.id}>
        <Tooltip title="Edit Template">
            <IconButton className="smallIconButton editColor">
                <EditIcon />
            </IconButton>
        </Tooltip>
    </Link>
}];

export default pageTemplatesGridColumns;


// WEBPACK FOOTER //
// ./src/containers/templates/TemplatesGridColumns.jsx